import React from 'react';
import SarasButton from '../../input/buttons/button/SarasButton';
import SarasConfirmPrompt from '../../notifications/SarasConfirmPrompt';
import SarasTrans from '../../notifications/SarasTrans';
import Draggable from 'react-draggable';

//use this dialog where form is draggable and actions are rendered by the dialog 
//out of the following choices: confirm, cancel and close actions
const SarasDialogDefAction = (props)=>{
    const {formStyle, title, 
        disableFormActions,
        actionName, cancelName, closeName, 
        confirmAction, confirmCancel, confirmClose,
        actionFunction, cancelFunction, closeFunction, 
        actionKSC, cancelKSC, closeKSC, contentStyle, children} = props

    const [confirmPromptData, setConfirmPromptData] = React.useState({})

    const onActionClick = (e) => {
        if(confirmAction && confirmAction.length > 0)
        {
            setConfirmPromptData({message:confirmAction, actionName:actionName, callback:executeOnAction});
        }
        else{
            executeOnAction();
        }
    }

    const onCancelClick = (e) => {
        if(confirmCancel && confirmCancel.length > 0)
        {
            setConfirmPromptData({message:confirmCancel, actionName:cancelName, callback:executeOnCancel});
        }
        else{
            executeOnCancel();
        }
    }

    const onCloseClick = (e) => {
        if(confirmClose && confirmClose.length > 0)
        {
            setConfirmPromptData({message:confirmClose, callback:executeOnClose});
        }
        else{
            executeOnClose()
        }
    }

    const executeOnAction = (e) => {
        if(actionFunction && typeof actionFunction === 'function') {
            actionFunction(e);
        }
    }

    const executeOnCancel = (e) => {
        if(cancelFunction && typeof cancelFunction === 'function') {
            cancelFunction(e);
        }
    }

    const executeOnClose = (e) => {
        if(closeFunction && typeof closeFunction === 'function') {
            closeFunction(e);
        }
    }
    
    const renderViewActions = () => {
        if(actionName || cancelName || closeName )
            return(
                <div className="phViewAction uiDialog">
                    <div className="uiDialogAction" style={{clear: "both"}}>
                        <div className="phAction uiFlexBox15">
                            {
                                !actionName ? '' : <SarasButton disabled={disableFormActions} ksc={actionKSC} className="uiSaveAction" 
                                                    starIcon="confirm"
                                                    onClick={onActionClick}>{actionName}</SarasButton>
                            }
                            {
                                !cancelName ? '' : <SarasButton disabled={disableFormActions} ksc={cancelKSC} className="uiCancelAction" 
                                                    starIcon="cancel"
                                                    onClick={onCancelClick}>{cancelName}</SarasButton>
                            }
                            {
                                !closeName ? '' : <SarasButton disabled={disableFormActions} ksc={closeKSC} className="uiCancelAction"
                                                    starIcon="confirm"
                                                    onClick={onCloseClick}>{closeName}</SarasButton>
                            }
                        </div>
                        <div style={{clear: "both"}} />
                    </div>
                </div>
            )
    }

    return(
        <>
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <div className="uiDialogContent">
        <div className="phViewArea" style={formStyle ? formStyle : {}}
            aria-labelledby="draggable-dialog-title"
        >
            <div className='phPopupContainer' >
                <div className="phViewHeading" style={{ cursor: 'move' }} id="draggable-dialog-title">
                    <div className="phTitle" >
                        <span><SarasTrans value = {title}/></span>
                    </div>
                </div>
                <div className="phPopupContent" style={contentStyle ? contentStyle : {}}>
                    {children}
                </div>
                {renderViewActions()}
            </div>
        </div>
        </div>
        </Draggable>
        <SarasConfirmPrompt promptData={confirmPromptData} />
        </>
    )
}

export default SarasDialogDefAction;
